import { useSelector } from 'react-redux';

import { CountryData } from '@components/country-code/types';

// The user slice is untyped (appConfig: null), so this selector stays loose.
const useSupportedPhoneCountries = (): CountryData[] => {
  const { appConfig } = useSelector((state: any) => state.user);
  return appConfig?.supported_phone_number_countries || [];
};

export default useSupportedPhoneCountries;
